import React from 'react';
import SimpleDateView from '../../components/SimpleDateView';
import moment from 'moment';

export const UserBadge = ({ userBadge = null, onChangeProfile = f => f }) => {

    if (userBadge === null) return null;

    const renderExpireDay = (userBadge) => {
        if ('Y' === userBadge.expireYn) {
            return <div className="expire expireY">{userBadge.expiredAt?.substring(0, 4)} 종료</div>;
        } else if (userBadge.expiredAt == null) {
            return <div className="expire unlimited">무제한</div>
        }
        const days = Math.abs(moment().startOf('day').diff(moment(userBadge.expiredAt).startOf('day'), 'days'));
        return <div className="expire expireN"><strong>{days}</strong> 남음</div>;
    }

    const onBadgeClick = () => {
        if (userBadge.expireYn !== "Y") {
            onChangeProfile(userBadge);
        }
    }

    return (
        <div className={`badge ${userBadge.expireYn === 'Y' ? 'expired' : ''} ${userBadge.active ? 'active' : ''}`} onClick={onBadgeClick} >
            <div className="profile_badge"><img src={`${process.env.PUBLIC_URL}/static/images/user/badge/profile_badge_icon.png`} alt="프로필 뱃지" /></div>
            <div className="badge_pic"><img src={userBadge.badgeImage} alt={userBadge.badgeName} /></div>
            <h5 className="name">{userBadge.badgeName}</h5>
            {userBadge.badgeDescription && <div className="desc">{userBadge.badgeDescription}</div>}
            {renderExpireDay(userBadge)}
            <SimpleDateView date={userBadge.createdAt} />
        </div>
    );
};